import { useState } from 'react';
import { EntityType } from '@/entities/entityConfig';
import { AppTable, AppTableProps } from '../AppTable';
import type { NavigationConfig } from '../AppTable/AppTable';
import { TableHeaderActions } from '../../components/TableHeaderActions';

interface ContainerTableProps<TData> extends Omit<AppTableProps<TData>, 'getSelectedItems'> {
  caption?: string;
  onHide?: (ids: number[]) => void;
  navigationConfig?: NavigationConfig<TData>[];
  entityName?: EntityType;
  onRowClick?: (row: TData) => void;
  hideTopActions?: boolean;
  onSelectedItemsChange?: (items: TData[]) => void;
  customTableBody?: (rows: any) => React.ReactNode;
}

export const ContainerTable = <T,>({
  onHide,
  navigationConfig,
  entityName,
  onRowClick,
  hideTopActions = false,
  onSelectedItemsChange,
  tableMeta,
  caption,
  ...tableProps
}: ContainerTableProps<T>) => {
  const [selectedRows, setSelectedRows] = useState<T[]>();

  const handleSelectedItems = (items: T[]) => {
    setSelectedRows(items);
    onSelectedItemsChange?.(items);
  };

  return (
    <div className="flex flex-col gap-4">
      {hideTopActions ? null : (
        <TableHeaderActions
          selectedRows={selectedRows}
          hideSelectedRow={onHide}
          entityName={entityName}
        />
      )}
      <AppTable
        getSelectedItems={handleSelectedItems}
        navigationConfig={navigationConfig}
        onRowClick={onRowClick}
        tableMeta={tableMeta}
        {...tableProps}
      />
    </div>
  );
};
